import React from "react";
import { twMerge } from "tailwind-merge";
import { CircularProgress } from "@mui/material";

const StagePathway = ({
  stages = [],
  activeStage = null,
  getStageLabel = () => {},
  getStageValue = () => {},
  onChange = () => {},
  isBusy = false,
}) => {
  const [activeState, setActiveStage] = React.useState("");

  // methods
  const handleGetStageLabel = React.useCallback(
    (stage) => getStageLabel(stage) ?? stage?.name,
    [getStageLabel]
  );

  const handleActiveStyles = (index) => {
    const defaultStyles = "text-sm p-1 text-gray-400";
    const activeStyles =
      "px-2 py-1 text-blue-50 dark:text-gray-600 text-sm bg-blue-500 dark:bg-blue-300 dark:border-gray-500 tracking-widest rounded";

    if (!activeState) return defaultStyles;

    return activeState === handleGetStageLabel(stages[index])
      ? activeStyles
      : defaultStyles;
  };

  const handleStageChange = (index) => {
    setActiveStage(handleGetStageLabel(stages[index]));
    onChange(
      getStageValue(stages[index]) ?? handleGetStageLabel(stages[index])
    );
  };

  React.useEffect(() => {
    if (!activeStage) return;
    setActiveStage(activeStage);
  }, [activeStage]);

  return (
    <div className="flex  h-8 w-full items-center justify-between py-2">
      {!isBusy ? (
        stages.map((stage, index) => (
          <React.Fragment key={index}>
            <div
              className="inline-block flex-shrink-0 cursor-pointer"
              onClick={() => handleStageChange(index)}
            >
              <div
                className={twMerge(
                  "font-medium transition-all duration-200 ease-in",
                  handleActiveStyles(index)
                )}
              >
                {handleGetStageLabel(stage)}
              </div>
            </div>

            {index !== stages.length - 1 && (
              <div className="w-full flex-grow border-t border-gray-300 dark:border-gray-500" />
            )}
          </React.Fragment>
        ))
      ) : (
        <div className="flex w-full justify-center">
          <CircularProgress size={24} />
        </div>
      )}
    </div>
  );
};

export default StagePathway;
